import React, { useEffect, useState, useRef } from 'react';
import { Container, Complemento } from './styles3';

import WebFont from "webfontloader";
import LogoErpWorks from "~/assets/logos/Logo ErpWorks Proposta Azul.png";
import CheckChecked from "~/assets/logos/check_proposta_checked.png";
import CheckUnChecked from "~/assets/logos/check_proposta_unchecked.png";

function Pagina3({ data, produtos }) {
  let linhas = "";//string.match(/(\r\n|\n|\r)/gm);
  let quantidadeLinhas = linhas ? linhas.length : 0;
  let resto = 0;

  return (
    <>
      <Container>
        <div className="barra-sup"></div>
        <div className="barra-sup2"></div>
        <div className="barra-sup3"></div>
        <div className="barra-sup4"></div>
        <div className="header">
          <div class="text">
            <p class="titulo">Data Emissão</p>
            <p class="titulo-data">{(new Date().toLocaleString('pt-BR', { timeZone: 'UTC' }))}</p>
          </div>
        </div>
        <div className="body">
          <div className="mid">
            <p class="titulo-orcamento">CRONOGRAMA</p>
            {data?.itens?.map((item) => (
              <div class="tabela">
                <div className="tab-header">
                  <p class="titulo-list">{item?.titulo}</p>
                  <div className="valor">
                    <p class="titulo">{((new Date(item?.dataPrevInicio)?.toLocaleString('pt-BR', { timeZone: 'UTC' }).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p>
                    <p class="titulo">{((new Date(item?.dataPrevFinal)?.toLocaleString('pt-BR', { timeZone: 'UTC' }).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p>
                    <p class="titulo">{item?.percentualEvolucao}%</p>
                  </div>
                </div>
                <div class="list">
                  {item?.itensAtividade?.map((itemAtv) => (
                    <div className="item">
                      <p class="titulo-item">{itemAtv?.titulo}</p>
                      <div className="valor">
                        <p class="titulo">{((new Date(itemAtv?.dataPrevInicio)?.toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p>
                        <p class="titulo">{((new Date(itemAtv?.dataPrevFinal)?.toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p>
                        <p class="titulo">{itemAtv?.responsabilidade == "E" ? "Erpworks" : "Cliente"}</p>
                        <p class="titulo">{itemAtv?.statusTarefa == "N" ? "Não Iniciado" : itemAtv?.statusTarefa == "E" ? "Em Execução" : "Concluído"}</p>
                        <p class="titulo">{itemAtv?.percentualEvolucao}%</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container >
    </>
  );
};

export default Pagina3;